/**
 * @file AdUnitSearchTopSlot.tsx
 *
 * @fileoverview Renders row ad unit for the top of the job search page.
 */

interface AdUnitSearchTopSlotProps {}

export default function AdUnitSearchTopSlot({}: AdUnitSearchTopSlotProps) {
  return <></>;
}

export { AdUnitSearchTopSlot };
